export const MODELS_DATA = [
  {
    id: "lawang_sewu_01",
    layerId: "3d-station-lawang-sewu",
    hitboxSourceId: "3d-hitbox-source-lawang-sewu",
    hitboxLayerId: "3d-hitbox-layer-lawang-sewu",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/lawang_sewu_3d.glb",
    centerCoordinate: [110.41063911254486, -6.9839779723281055],
    altitude: 0,
    scaleMultiplier: 3.5,
    rotationY: 225,
    hitboxPolygon: [
      [
        [110.4101363634652, -6.983389669200648],
        [110.41148130854918, -6.983389669200648],
        [110.41148130854918, -6.984367106602448],
        [110.4101363634652, -6.984367106602448],
        [110.4101363634652, -6.983389669200648],
      ],
    ],
    popupData: {
      buildingName: "Lawang Sewu",
      artist: "SAW IND",
    },
  },
  {
    id: "monas_01",
    layerId: "3d-station-monas",
    hitboxSourceId: "3d-hitbox-source-monas",
    hitboxLayerId: "3d-hitbox-layer-monas",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/monas.glb",
    centerCoordinate: [106.82717306357142, -6.175401658577812],
    altitude: 0,
    scaleMultiplier: 3.6,
    rotationY: 0,
    hitboxPolygon: [
      [
        [106.82691020709524, -6.175140654546425],
        [106.82742519122633, -6.175140654546425],
        [106.82742519122633, -6.17571664979279],
        [106.82691020709524, -6.17571664979279],
        [106.82691020709524, -6.175140654546425],
      ],
    ],
    popupData: {
      buildingName: "Monumen Nasional",
      artist: "KenanJL01",
    },
  },
  {
    id: "gedung_sate_01",
    layerId: "3d-station-gedung-sate",
    hitboxSourceId: "3d-hitbox-source-gedung-sate",
    hitboxLayerId: "3d-hitbox-layer-gedung-sate",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/gedung_sate_bandung.glb",
    centerCoordinate: [107.61878, -6.90265],
    altitude: 0,
    scaleMultiplier: 1,
    rotationY: 181,
    hitboxPolygon: [
      [
        [107.61824482819833, -6.902285520937809],
        [107.6193595044104, -6.902285520937809],
        [107.6193595044104, -6.903051344520449],
        [107.61824482819833, -6.903051344520449],
        [107.61824482819833, -6.902285520937809],
      ],
    ],
    popupData: {
      buildingName: "Gedung Sate",
      artist: "faradillarizki",
    },
  },
  {
    id: "gelora_bung_karno_01",
    layerId: "3d-station-gelora",
    hitboxSourceId: "3d-hitbox-source-gelora",
    hitboxLayerId: "3d-hitbox-layer-gelora",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/stadion_gelora_bung_karno.glb",
    centerCoordinate: [106.80264804336917, -6.2184834241069495],
    altitude: 0,
    scaleMultiplier: 1,
    rotationY: 0,
    hitboxPolygon: [
      [
        [106.80124847747447, -6.216715416732285],
        [106.80443415568544, -6.216715416732285],
        [106.80443415568544, -6.220446754011235],
        [106.80124847747447, -6.220446754011235],
        [106.80124847747447, -6.216715416732285],
      ],
    ],
    popupData: {
      buildingName: "Stadion Gelora Bung Karno",
      artist: "bareno",
    },
  },
  {
    id: "stasiun_tasikmalaya_01",
    layerId: "3d-station-tasikmalaya",
    hitboxSourceId: "3d-hitbox-source-tasikmalaya",
    hitboxLayerId: "3d-hitbox-layer-tasikmalaya",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/3D+STASIUN+TASIKMALAYA.glb",
    centerCoordinate: [108.224302, -7.32307],
    altitude: 0,
    scaleMultiplier: 1,
    rotationY: -52,
    hitboxPolygon: [
      [
        [108.22214921501615, -7.32019884630968],
        [108.22575169772244, -7.32019884630968],
        [108.22575169772244, -7.324253301945106],
        [108.22214921501615, -7.324253301945106],
        [108.22214921501615, -7.32019884630968],
      ],
    ],
    popupData: {
      buildingName: "Stasiun Tasikmalaya",
      artist: "PT KAI",
    },
  },
  {
    id: "masjid_raya_bandung_01",
    layerId: "3d-station-masjid-raya-bandung",
    hitboxSourceId: "3d-hitbox-source-masjid-raya-bandung",
    hitboxLayerId: "3d-hitbox-layer-masjid-raya-bandung",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/masjid_raya_bandung.glb",
    centerCoordinate: [107.60651, -6.9222],
    altitude: 0,
    scaleMultiplier: 0.025,
    rotationY: 0,
    hitboxPolygon: [
      [
        [107.60593827402732, -6.921452329319166],
        [107.60649171259274, -6.921452329319166],
        [107.60649171259274, -6.922130877168314],
        [107.60593827402732, -6.922130877168314],
        [107.60593827402732, -6.921452329319166],
      ],
    ],
    popupData: {
      buildingName: "Masjid Raya Bandung",
      artist: "aurorananjelita0304",
    },
  },
  {
    id: "gereja_blenduk",
    layerId: "3d_gereja_blenduk",
    hitboxSourceId: "3d_hitbox_source_gereja_blenduk",
    hitboxLayerId: "3d_hitbox_layer_gereja_blenduk",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/gereja_blenduk.glb",
    centerCoordinate: [110.42747422050246, -6.968191554026745],
    altitude: 0,
    scaleMultiplier: 1,
    rotationY: 92,
    hitboxPolygon: [
      [
        [110.4274073761373, -6.968070859784618],
        [110.42752271112505, -6.968070859784618],
        [110.42752271112505, -6.968241253224562],
        [110.4274073761373, -6.968241253224562],
        [110.4274073761373, -6.968070859784618],
      ],
    ],
    popupData: {
      buildingName: "GPIB Immanuel Semarang/Gereja Blenduk",
      artist: "farrelzakifahrezi",
    },
  },
  {
    id: "istora_senayan",
    layerId: "3d_istora_senayan",
    hitboxSourceId: "3d_hitbox_source_istora_senayan",
    hitboxLayerId: "3d_hitbox_layer_istora_senayan",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/istora_senayan_jakarta.glb",
    centerCoordinate: [106.80573004956278, -6.22032859889444],
    altitude: 0,
    scaleMultiplier: 1,
    rotationY: 90,
    hitboxPolygon: [
      [
        [106.80545023765853, -6.219951484519228],
        [106.80586704404698, -6.219951484519228],
        [106.80586704404698, -6.220737634325346],
        [106.80545023765853, -6.220737634325346],
        [106.80545023765853, -6.219951484519228],
      ],
    ],
    popupData: {
      buildingName: "Istora Senayan/Istana Olahraga Gelora Bung Karno",
      artist: "alif.iqbal.rizki",
    },
  },
  {
    id: "monumen_selamat_datang",
    layerId: "3d_monumen_selamat_datang",
    hitboxSourceId: "3d_hitbox_source_monumen_selamat_datang",
    hitboxLayerId: "3d_hitbox_layer_monumen_selamat_datang",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/selamat_datang.glb",
    centerCoordinate: [106.82304, -6.19442],
    altitude: 0,
    scaleMultiplier: 1,
    rotationY: 0,
    hitboxPolygon: [
      [
        [106.82300132211702, -6.194901193050811],
        [106.82316002305697, -6.194901193050811],
        [106.82316002305697, -6.195061003040308],
        [106.82300132211702, -6.195061003040308],
        [106.82300132211702, -6.194901193050811],
      ],
    ],
    popupData: {
      buildingName: "Monumen Selamat Datang",
      artist: "alif.iqbal.rizki",
    },
  },
  {
    id: "spiegel",
    layerId: "3d_spiegel",
    hitboxSourceId: "3d_hitbox_source_spiegel",
    hitboxLayerId: "3d_hitbox_layer_spiegel",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/spiegel.glb",
    centerCoordinate: [110.42857, -6.96821],
    altitude: 0,
    scaleMultiplier: 0.022,
    rotationY: 0,
    hitboxPolygon: [
      [
        [110.42843865137019, -6.968150232579234],
        [110.42855643238732, -6.968150232579234],
        [110.42855643238732, -6.968264099062921],
        [110.42843865137019, -6.968264099062921],
        [110.42843865137019, -6.968150232579234],
      ],
    ],
    popupData: {
      buildingName: "Spiegel",
      artist: "FikriansyahDwivirti",
    },
  },
  {
    id: "museum_mandala_bhakti",
    layerId: "3d_museum_mandala_bhakti",
    hitboxSourceId: "3d_hitbox_source_museum_mandala_bhakti",
    hitboxLayerId: "3d_hitbox_layer_museum_mandala_bhakti",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/museum_mandala_bhakti.glb",
    centerCoordinate: [110.40879, -6.98479],
    altitude: 0,
    scaleMultiplier: 0.0233,
    rotationY: 0,

    hitboxPolygon: [
      [
        [110.40866339647903, -6.984590760871242],
        [110.40887265083927, -6.984590760871242],
        [110.40887265083927, -6.9849612000714245],
        [110.40866339647903, -6.9849612000714245],
        [110.40866339647903, -6.984590760871242],
      ],
    ],
    popupData: {
      buildingName: "Museum Mandala Bhakti",
      artist: "AndhikaPrasista",
    },
  },
  {
    id: "hotel_kotta",
    layerId: "3d_hotel_kotta",
    hitboxSourceId: "3d_hitbox_source_hotel_kotta",
    hitboxLayerId: "3d_hitbox_layer_hotel_kotta",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/hotel_kotta.glb",
    centerCoordinate: [110.42818, -6.967881],
    altitude: 0,
    scaleMultiplier: 0.0233,
    rotationY: 0,
    hitboxPolygon: [
      [
        [110.42808802226409, -6.967727330605314],
        [110.42823090216797, -6.967727330605314],
        [110.42823090216797, -6.968030703836931],
        [110.42808802226409, -6.968030703836931],
        [110.42808802226409, -6.967727330605314],
      ],
    ],
    popupData: {
      buildingName: "Dijkstra Kota Lama/Hotel Kotta",
      artist: "cantika.prameswari0503",
    },
  },
  {
    id: "suro_boyo",
    layerId: "3d_suro_boyo",
    hitboxSourceId: "3d_hitbox_source_suro_boyo",
    hitboxLayerId: "3d_hitbox_layer_suro_boyo",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/suroboyo.glb",
    centerCoordinate: [112.73868, -7.29599],
    altitude: 0,
    scaleMultiplier: 0.04,
    rotationY: 0,
    hitboxPolygon: [
      [
        [112.73865874263095, -7.2959711486229395],
        [112.73870031687096, -7.2959711486229395],
        [112.73870031687096, -7.296013051372626],
        [112.73865874263095, -7.296013051372626],
        [112.73865874263095, -7.2959711486229395],
      ],
    ],
    popupData: {
      buildingName: "Patung Suro dan Boyo",
      artist: "hynect",
    },
  },
  {
    id: "pandanaran",
    layerId: "3d_pandanaran",
    hitboxSourceId: "3d_hitbox_source_pandanaran",
    hitboxLayerId: "3d_hitbox_layer_pandanaran",
    url: "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/pandanaran.glb",
    centerCoordinate: [110.41010932149237, -6.983024666254863],
    altitude: 0,
    scaleMultiplier: 70,
    rotationY: -45,
    hitboxPolygon: [
      [
        [110.40999963116695, -6.982929617939504],
        [110.41025937100864, -6.982929617939504],
        [110.41025937100864, -6.98311038713662],
        [110.40999963116695, -6.98311038713662],
        [110.40999963116695, -6.982929617939504],
      ],
    ],
    popupData: {
      buildingName: "Gedung Pandanaran",
      artist: "nada.nafilatu.zulfa",
    },
  },
];
